module.exports = __webpack_public_path__ + "img/payment_failure_move.a33a4394.png";